<script setup lang="ts">
import { computed } from 'vue';

import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppRawButton, AppSvgIcon } from '@libs/ui';
import type { AppSvgIconType } from '@libs/ui';

interface DrawerButtonProps {
  isExtended: boolean;
}

const props = defineProps<DrawerButtonProps>();

interface DrawerButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<DrawerButtonEmits>();

const { t } = i18n.global;

const icon = computed<AppSvgIconType>(() =>
  props.isExtended ? 'chevronUp' : 'chevronDown'
);

const text = computed<string>(() =>
  props.isExtended
    ? t('planner.hide_30_days_calendar')
    : t('planner.show_30_days_calendar')
);
</script>

<template>
  <AppRawButton class="drawer-button" @click="emit('click')">
    {{ text }}
    <AppSvgIcon :name="icon" />
  </AppRawButton>
</template>

<style scoped lang="scss">
.drawer-button {
  padding: 1px var(--spacing-8) 1px var(--spacing-12);
  background-color: var(--color-white);
  color: var(--color-neutral-70);
  @include font-label-s-light;
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-30);
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  white-space: nowrap;
}
</style>
